import * as React from 'react';
import Organization from 'entities/Organization';
import Text from 'components/Text';

type Props = {
  school: Organization;
}

class SchoolColleaguesRow extends React.Component<Props> {
  render() {
    const { school } = this.props;
    const members = school.getMemberSampleString();
    return (
      <div className="SchoolColleaguesRow">
        <Text truncate>{members === undefined ? 'No school members' : members}</Text>
      </div>
    );
  }
}

export default SchoolColleaguesRow;
